export type LandingScreenshotKey = "funding-calculator" | "investor-business-plan";

type LandingScreenshotMeta = {
  webp: string;
  png: string;
  width: number;
  height: number;
  alt: string;
  frameTitle: string;
  badge?: string;
  maxHeightClass: string;
};

export const LANDING_SCREENSHOTS: Record<LandingScreenshotKey, LandingScreenshotMeta> = {
  "funding-calculator": {
    webp: "/landing/funding-calculator.webp",
    png: "/landing/funding-calculator.png",
    width: 1280,
    height: 1068,
    alt: "BurnChart Funding ASK Calculator showing Survival, Growth, and Series Prep raise scenarios from live burn rate",
    frameTitle: "Funding ASK Calculator",
    maxHeightClass: "lg:max-h-[min(560px,72vh)]",
  },
  "investor-business-plan": {
    webp: "/landing/investor-business-plan.webp",
    png: "/landing/investor-business-plan.png",
    width: 1280,
    height: 1892,
    alt: "BurnChart investor business plan with MRR projections, customer growth chart, cash position, and operating cost breakdown",
    frameTitle: "Investor business plan",
    badge: "Read-only",
    maxHeightClass: "lg:max-h-[min(620px,78vh)]",
  },
};
